$(document).ready(function () {
    let login_errors = $('.login-errors');
    //login-form
    $('.login-form').on('submit', function (e) {
        e.preventDefault();

        axios({
            url: "/auth/login",
            method: 'POST',
            data: $(this).serialize(),
            dataType: 'json',
        }).then(function (data) {
            login_errors.html("");
            login_errors.addClass('d-none');

            if (data.data.success) {
                if(data.data.uniqueCacheId) {
                    location.href = "/?cache=" + data.data.uniqueCacheId;
                } else {
                    location.href = "/";
                }
            } else {
                let errors = Array();
                $.each(data.data.errors, function () {
                    $.each(this, function () {
                        errors.push(this);
                    });
                });

                if (errors.length) {
                    login_errors.html(errors.join('<br />'));
                    login_errors.removeClass('d-none');
                }
            }
        });
    });

    $('#newsletter-form').on('submit', function (e) {
        e.preventDefault();
        let responseHtml = $('.newsletter-response');
        let form = $(this);
        responseHtml.css('visibility', 'hidden').empty();
        axios({
            url: "/laposta/register",
            method: 'POST',
            data: $(this).serialize(),
            dataType: 'json',
        }).then(function (response) {
            let data = response.data;
            if(data.success) {
                form[0].reset();
                form.find('.newsletter-form-wrapper').hide();
                responseHtml.css({"color": "green", "visibility": "visible"}).text(data.message);
            } else {
                responseHtml.css({"color": "red", "visibility": "visible"}).text(data.message);
            }
        }).catch(function (err) {
            let errors = err.response.data.errors;
            errors = $.map(errors, function (error) {
                return error;
            });
            responseHtml.html(errors.join('<br />')).css({"color": "red", "visibility": "visible"});
        });
    });

    //AJAX search results -- Header
    let debounce_search = 0;

    function fetch_search_results(query = '') {
        $.ajax({
            url: "/ajax/search/json",
            method: 'GET',
            data: {
                query: query
            },
            dataType: 'json',
            success: function (data) {
                addSearchResults(data)
            }
        });
    }

    function addSearchResults(data) {
        let results = false;
        let markup = `
        <ul class="search_items">`

        if (data.categories.length > 0) {
            results = true;
            markup += `
            <div class="text-primary">Categorieën:</div>
            ${data.categories.map(item => `
            <li>
              <a href="${item.url}">
                  <span class="search-title">${item.title}</span>
              </a>
            </li>`).join('')}
            `
        }
        if (data.productTags.length > 0) {
            results = true;
            markup += `
            <div class="text-primary">Product tags:</div>
            ${data.productTags.map(item => `
            <li>
              <a href="${item.url}">
                  <span class="search-title">${item.title}</span>
              </a>
            </li>`).join('')}
            `
        }
        if (data.products.length > 0) {
            results = true;
            markup += `
            <div class="text-primary">Assortiment:</div>
            ${data.products.map(item => `
            <li>
              <a href="${item.url}">
                <img class="search-image" loading="lazy" height="45=" width="45" src="${item.img}" alt="${item.title}" title="${item.title}">
                <span class="search-title">${item.title}</span>
              </a>
            </li>`).join('')}
            `;
        }
        markup += `</ul>`;

        if(results) {
            $('.searchitems').html(markup);
            $('#searchitems').addClass('show');
        }
    }

    $(document).on('keyup', '#searchbar', function (e) {
        var query = $(this).val();

        if (query !== '') {
            if (e.keyCode == 13) {
                location.href = "/search?query=" + encodeURIComponent(query);
            } else {
                clearTimeout(debounce_search);
                debounce_search = setTimeout(function () {
                    fetch_search_results(query);

                    if ($('#searchbar').val().length == 0) {
                        $('#searchitems').removeClass('show');
                    }
                }, 200);
            }
        }
    });

    $(document).on('click', '.search__button', function (e) {
        var query = $('#searchbar').val();

        if (query !== '') {
            location.href = "/search?query=" + encodeURIComponent(query);
        }
    });

    $('body').not('#searchitems').click(function () {
        $('#searchitems').removeClass('show');
    });
});
